/**
 * 运维大区
 */
import { getConfig } from './server-url-config/env';
import { get } from 'src/utils/request-manager';

const urlConfig = getConfig();

const baseUrl = `${urlConfig.apiUrl.cedar}`

// 获取新版运维大区 version取值1（旧版）取值2（新版）取值3（兼容新旧版本）
export async function getMaintenanceArea(version) {
  return get(`${baseUrl}/refs/maintenanceRegions?version=${version || 3}`)
}
